
  var _styles = {
  "magicmember-coupon-button": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "overflow": "hidden"
  },
  "magicmember-coupon-primary-button": {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "flex-start"
  },
  "magicmember-coupon-plain-button": {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "background": "#fff"
  }
};



  module.exports = _styles;
  